/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_OnlineInputs */

const vi_order_channel_online = /** @type {(inputs: Order_Channel_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

/**

* @param {Order_Channel_OnlineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_online = /** @type {((inputs?: Order_Channel_OnlineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_OnlineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_online(inputs)
});